import React, { FC } from 'react'
import styles from 'styles/components/list.module.scss'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { DepositHistoryListItem } from 'components/List'
import { useQueryShopPayouts, usePayoutYears } from 'hooks/revenue'
import { CautionCard } from 'components/Card'
import { getShopRef } from 'reducks/store/selectors'

const DepositHistoryList: FC = () => {
  const shopRef = useSelector((state: State) => getShopRef(state))
  const payouts = useQueryShopPayouts(shopRef?.id, 100)
  // 管理画面を開設した月の翌月以降から、先月までを表示する
  const years = usePayoutYears(payouts)
  return (
    <ul className={styles.monthlyReport}>
      {years.length > 0 ? (
        years.map((year) => {
          const payoutsOfTheYear = payouts.filter((payout) => new Date(payout.createdDate).getFullYear() === year)
          return <DepositHistoryListItem key={year} payouts={payoutsOfTheYear} year={year} />
        })
      ) : (
        <CautionCard caution={'入金履歴明細がまだありません。'} size={'small'} />
      )}
    </ul>
  )
}

export default DepositHistoryList
